enum BiteLogSquareEvent {
  None = 0,
  AuthorizationSuccess = 1,
  AuthorizationError = 2,
  ReaderSettingsSuccess = 3,
  ReaderSettingsError = 4,
  CheckoutErrorDeprecated = 5,
  ReaderDisconnected = 6,
  CheckoutCancelled = 7,
  CheckoutErrNotAuthorized = 8,
  CheckoutErrUsageError = 9,
  CheckoutTimeout = 10,
  CheckoutNoNetwork = 13,
  CheckoutLocationServicesDisabled = 14,
  PairingSuccess = 11,
  PairingError = 12,
}

export { BiteLogSquareEvent };
